// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionReports.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');

  var PermissionReportHeader = require('./Izenda.PermissionReportHeader');
  var PermissionReportBody = require('./Izenda.PermissionReportBody');
  var PermissionReportFooter = require('./Izenda.PermissionReportFooter');
  var actions = require('../Izenda.PermissionActions');
  var SECTION = require('logic/data/Izenda.PermissionConstants').SECTION;
  var EventsUtils = require('EventUtils');
  var UNCHECK_VALUE = 0;
  var CheckboxAllPermission = require('./Izenda.CheckboxAllPermission');
  const { isNil, get } = require('lodash/fp');

  var PermissionReports = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.reports = this.props.permission.reports;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var isTemplatePermissions = this.props.isTemplatePermissions;
      var reports = get('reports', tenantDetail);

      return (
        !permission.fullReportAndDashboardAccess &&
        (isNil(tenantDetail) || tenantDetail.reports.tenantAccess !== UNCHECK_VALUE) && (
          <div className={SECTION.Reports}>
            <GridLayout className='izenda-GridLayout-Custom'>
              <GridLayout.Row className='u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header'>
                <GridLayout.Col cols={2}>
                  <a
                    className={this.props.getIconClass('isShowReports')}
                    onClick={this.props.toggle.bind(this, 'isShowReports')}
                  />
                  {localization.getText('COMMON_LABEL_REPORTS')}
                </GridLayout.Col>
                <GridLayout.Col cols={9}>
                  <CheckboxAllPermission
                    permission={permission}
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    section={this.reports}
                    tenantPermission={reports}
                    tenantDetail={tenantDetail}
                  />
                </GridLayout.Col>
                {permission.isTenantSetup && (
                  <GridLayout.Col cols={1} className='u_textCenter'>
                    <Input
                      type='checkbox'
                      readOnly={this.props.readOnly}
                      disabled={isTemplatePermissions}
                      indeterminate={this.props.getIndeterminateCommon(this.reports)}
                      checked={this.props.getCheckedCommon(this.reports.tenantAccess)}
                      onChange={notifyChange(
                        permission.updateTenantAccessParent.bind(permission, this.reports),
                        EventsUtils.CHECKBOX
                      )}
                    />
                  </GridLayout.Col>
                )}
              </GridLayout.Row>
            </GridLayout>
            {permissionStore.isShowReports && (
              <div>
                <PermissionReportHeader {...this.props} />
                <PermissionReportBody {...this.props} />
                <PermissionReportFooter {...this.props} />
              </div>
            )}
          </div>
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionReports);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionReports.jsx